<template>
  <base-progress
    v-slot="{ percentage }"
    :aria-label="replaceAll($t.ratingLabel, { value, max })"
    class="relative"
    data-test-id="vf-rating"
    :max
    role="img"
    :style="{ width: `${pxToRem(+max * sizes[size])}` }"
    :value
  >
    <vf-icon
      class="absolute c-grey-70"
      :name="`${icon}`"
      :size
      :style="{ ...maskStyles, width: '100%' }"
    />
    <vf-icon
      class="c-brand-1"
      :name="`${icon}`"
      :size
      :style="{ width: `${percentage}%`, ...maskStyles }"
    />
  </base-progress>
</template>

<script lang="ts" setup>
import type { IconSizes } from '#types/sizes'

const {
  icon = 'star-filled',
  size = 'sm',
  max = 5,
  value = 0
} = defineProps<{
  /**
   * Custom icon name
   */
  icon?: string
  /**
   * Size of rating icon
   */
  size?: IconSizes
  /**
   * Defines maximum items in a rating (5, 10, etc.)
   */
  max?: number | string
  /**
   * Defines current rating, can be floating number or a string that will be converted to a number
   */
  value?: number | string
}>()

const { size: sizes } = useAppConfig().components.vf.icon

const maskStyles = computed(() => ({
  'mask-repeat': 'repeat',
  '-webkit-mask-repeat': 'repeat',
  'mask-size': `${pxToRem(sizes[size])} 100%`,
  '-webkit-mask-size': `${pxToRem(sizes[size])} 100%`
}))
</script>
